import { render, staticRenderFns } from "./SortMobile.vue?vue&type=template&id=60a8da56&scoped=true&"
import script from "./SortMobile.vue?vue&type=script&lang=js&"
export * from "./SortMobile.vue?vue&type=script&lang=js&"
import style0 from "./SortMobile.vue?vue&type=style&index=0&id=60a8da56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a8da56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\corporate-builder\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a8da56')) {
      api.createRecord('60a8da56', component.options)
    } else {
      api.reload('60a8da56', component.options)
    }
    module.hot.accept("./SortMobile.vue?vue&type=template&id=60a8da56&scoped=true&", function () {
      api.rerender('60a8da56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CorporateBuilder/components/Step2Mobile/SortMobile.vue"
export default component.exports